import { createLoadableComponent, createModuleLoader } from '@mews/framework';

import { createViewLoadingError } from '../../components/common/createViewLoadingError';

import { moduleId } from './constants';

export const loader = createModuleLoader({
    name: moduleId,
    load: async () => import(/* webpackChunkName: "dates" */ './module'),
    dependencies: [],
});

export const Dates = createLoadableComponent({
    loader,
    component: 'DatesView',
    ...createViewLoadingError({}),
});
